import React from 'react';
import PropTypes from 'prop-types';
import { Svg } from '@jg/components';
import config from 'config/config';
import defaultCharity from './charity-default.svg';

export default class CharityImage extends React.Component {
  static propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    classNames: PropTypes.string,
  };

  static defaultProps = {
    src: '',
    alt: '',
    classNames: '',
  }

  state = {
    errored: false,
  }

  handleError = () => {
    this.setState({ errored: true });
  };

  render() {
    const { src, alt, classNames } = this.props;
    const { errored } = this.state;
    if (errored || !src || src.includes('No_image')) {
      return <Svg markup={defaultCharity} alt={alt} className={classNames} />;
    }
    const srcURI = `${config.IMAGE_SERVICE_URL}/${src}`;
    return <img className={classNames} src={srcURI} alt={alt} onError={this.handleError} />;
  }
}



// WEBPACK FOOTER //
// ./components/CharityImage/CharityImage.js